import TOC from "./TOC";
import TopLevelTOC from "./TopLevelTOC";

export default TOC;

export { TOC, TopLevelTOC };
